import React from 'react';
import { Button, Tooltip } from 'antd';
import { TimeKeeperEmployer } from '@/DTOS/TimeKeeperEmployer/Response/TimeKeeperEmployer';
import { EditOutlined} from '@ant-design/icons';

export const TimeKeeperEmployerColumn = (
  handleEdit: (record: TimeKeeperEmployer) => void
) => [
  
  {
    title: 'Employer Id',
    dataIndex: 'id',
    key: 'id',
    hidden: true,
  },
  {
    title: 'Nume',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: 'Referinta',
    dataIndex: 'reference',
    key: 'reference',
  },
  {
    title: 'Actiune',
    key: 'actions',
    render: (record: TimeKeeperEmployer) => (
      <Tooltip title='Modifica'>
      <Button onClick={() => handleEdit(record)} icon={<EditOutlined/>}></Button>
      </Tooltip>
    ),
    width: 120,
    fixed: 'right'
  },
];
